/*
 * � 2020 Microsoft. All rights reserved.
 */

define('util/TipManager',[
    'absolute/stringmanager',
    'absolute/coords',
    'util/SettingsManager',
    'MenuUI/TipDialog',
    'Managers/ScaleManager'
], function (_s, Coords, SettingsManager, TipDialog, ScaleManager) {
    "use strict";

    var TipManager = {

        ui: null,

        game: null,

        settingsManager: null,

        init: function (ui, game, gameScreenUI) {
            this.ui = ui;
            this.game = game;
            this.gameScreenUI = gameScreenUI;
            this.settingsManager = SettingsManager;
            this.dialogShowing = false;
        },

        tryShowTip: function (tipEventArgs) {

            /*console.log("tryShowTip " + tipEventArgs.TipId);
            console.log(_s(tipEventArgs.TipId, tipEventArgs.Args));*/

            if (this.settingsManager.getSetting("general", "showAlerts") && !this.game.solitaire.Authority.IsChallenge) {

                // make sure tip isn't already there
                var skipTween = false;
                if(this.tipDialog) {
                    window.clearTimeout(this.hideTimer);
                    skipTween = true;
                }

                var message = _s(tipEventArgs.TipId, tipEventArgs.Args);
                if(skipTween) {
                    this.dialogShowing = true;
                    if (message !== this.tipDialog.text) {
                        this.tipDialog.updateText(message);
                        this.tipDialog.resize();
                    }
                } else {
                    this.tipDialog = new TipDialog(tipEventArgs, {}, this.hideTipDialog.bind(this), this.setShowAlerts.bind(this));
                    this.tipDialog.position.x = -this.tipDialog.width;
                    this.game.menuBar.addChild(this.tipDialog);

                    var endX = Coords.x(15),
                        self = this;
                    this.tipDialog.resize();
                    this.showTipTween = new TWEEN.Tween({ x: this.tipDialog.position.x })
                        .to({x: endX }, 250)
                        .easing(TWEEN.Easing.Cubic.InOut)
                        .onUpdate(function () {
                            if (self.tipDialog) {
                                self.tipDialog.x = this.x;
                                self.tipDialog.updateText(message);
                                self.tipDialog.resize();
                            }
                        })
                        .onComplete(function () {
                            self.dialogShowing = true;
                            if (self.tipDialog) {
                                self.tipDialog.updateText(message);
                                self.tipDialog.resize();
                            }
                        })
                        .start();
                }

                this.hideTimer = setTimeout(function () {
                    this.hideTipDialog();
                }.bind(this), 5000);
            }
        },

        hideTipDialog: function () {
            window.clearTimeout(this.hideTimer);
            if (this.showTipTween && this.showTipTween.Stop) this.showTipTween.Stop();
            if (this.tipDialog) {
                var endX = -this.tipDialog.width,
                    self = this;
                this.hideTipTween = new TWEEN.Tween({ x: this.tipDialog.position.x })
                    .to({x: endX }, 250)
                    .easing(TWEEN.Easing.Cubic.InOut)
                    .onUpdate(function () {
                        if(self.tipDialog) {
                            self.tipDialog.x = this.x;
                        }
                    })
                    .onComplete(function () {
                        if (self.tipDialog) {
                            if (self.gameScreenUI.children.indexOf(self.tipDialog) != -1) {
                                self.gameScreenUI.removeChild(self.tipDialog);
                            }
                            self.tipDialog.removeScaling();
                            self.tipDialog = null;
                        }
                        self.dialogShowing = false;
                    })
                    .start();
            }
        },

        setShowAlerts: function (show) {
            this.settingsManager.setSetting("general", "showAlerts", show);
        }
    };

    return TipManager;

});

